import ArchiveIcon from "@assets/icons/Archive.svg?react";
import UnarchiveIcon from "@assets/icons/Unarchive.svg?react";
import ShareIcon from "@assets/icons/Share.svg?react";
import { FaroIconButton } from "@components/common/faro-icon-button";
import { SphereTooltip } from "@components/common/sphere-tooltip";
import { DeleteProject } from "@pages/project-details/project-overview/delete-project";
import { ActionButtonContainer } from "@components/action-buttons/action-button-container";
import { BaseProjectProps } from "@custom-types/project-types";
import { useProjectActions } from "@hooks/projects/use-project-actions";
import DeleteIcon from "@assets/icons/new/delete_32px.svg?react";
import { useState } from "react";

/**
 * List of all the buttons that will be shown on project overview tab
 */
export function ProjectOverviewActionButtons({
  project,
}: BaseProjectProps): JSX.Element {
  const [shouldShowDialog, setShouldShowDialog] = useState<boolean>(false);
  const {
    handleShareProject,
    archiveOrUnarchiveProject,
    isProjectActive,
    isAllowedToArchiveOrUnarchive,
    isArchiveActionDisabled,
    canDeleteProject,
  } = useProjectActions(project);

  return (
    <>
      {/* Button to Archive / Unarchive project */}
      {isAllowedToArchiveOrUnarchive && (
        <ActionButtonContainer>
          <SphereTooltip
            title={`${isProjectActive ? "Archive" : "Unarchive"} project`}
          >
            <FaroIconButton
              isDisabled={isArchiveActionDisabled}
              component={isProjectActive ? ArchiveIcon : UnarchiveIcon}
              onClick={() => archiveOrUnarchiveProject()}
            />
          </SphereTooltip>
        </ActionButtonContainer>
      )}

      {/* Button to share a link to the project */}
      <ActionButtonContainer>
        <SphereTooltip
          title="Share project"
          boxProps={{
            sx: {},
          }}
        >
          <FaroIconButton
            component={ShareIcon}
            onClick={handleShareProject}
          />
          </SphereTooltip>
      </ActionButtonContainer>

      {/* Button to delete a project */}
      {!isProjectActive && canDeleteProject && (
        <ActionButtonContainer>
          <SphereTooltip title="Delete Project">
            <FaroIconButton
              component={DeleteIcon}
              onClick={() => setShouldShowDialog(true)}
            />
          </SphereTooltip>
        </ActionButtonContainer>
      )}
      
      {/* Render DeleteProject dialog */}
      {shouldShowDialog && (
        <DeleteProject
          project={project}
          onClose={() => setShouldShowDialog(false)}
        />
      )}
    </>
  );
}
